export const BUSINESS = {
  name: "Jaiswal Tent House",
  tagline: "Making Every Celebration Special.",
  description:
    "We provide beautiful tent arrangements and decoration services for weddings, receptions, birthdays, parties, and all special occasions. Let us make your celebrations memorable with attractive designs and dependable service.",
  location: "Bilaspur, Chhattisgarh, India",
  address: "Bilaspur, Chhattisgarh 495001, India",
  phone: "92038616540",
  phoneHref: "tel:92038616540",
  whatsapp: "9399342312",
  whatsappHref: "https://wa.me/9399342312",
  mapsEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d59392.21545620956!2d82.1128821!3d22.0797175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a280b1300000001%3A0x6b4db3b01e7e408d!2sBilaspur%2C%20Chhattisgarh!5e0!3m2!1sen!2sin!4v1710000000000!5m2!1sen!2sin",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Bilaspur%2C+Chhattisgarh",
};

export const ADMIN_PIN = "2025";

export const waLink = (message) =>
  `${BUSINESS.whatsappHref}?text=${encodeURIComponent(message)}`;

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/services" },
  { label: "Gallery", path: "/gallery" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1772127822525-7eda37383b9f?q=85&w=1600&auto=format&fit=crop";

const img = (id) => `https://images.unsplash.com/${id}?q=85&w=900&auto=format&fit=crop`;

export const SERVICES = [
  {
    slug: "wedding-tent-decoration",
    title: "Wedding Tent & Decoration",
    image: img("photo-1772127822525-7eda37383b9f"),
    short:
      "Grand wedding tents with elegant drapes, floral accents and warm lighting — arranged end-to-end for your big day.",
    features: [
      "Waterproof shamiyana & hangar tents",
      "Elegant drape & ceiling decor",
      "Floral and lighting styling",
      "Complete setup and takedown",
    ],
  },
  {
    slug: "tent-pandal-setup",
    title: "Tent and Pandal Setup",
    image: img("photo-1657816925116-9bbb2a45fb6d"),
    short:
      "Strong, weather-ready pandals in every size — from intimate gatherings to large community functions.",
    features: [
      "Sizes for small to large guest counts",
      "Sturdy poles, flooring & seating layout",
      "Side walls, entrances & pathways",
      "On-site supervision throughout",
    ],
  },
  {
    slug: "wedding-stage-decoration",
    title: "Wedding Stage Decoration",
    image: img("photo-1708606811579-23b18fc48007"),
    short:
      "A picture-perfect stage that becomes the centrepiece of your wedding — designed around your theme.",
    features: [
      "Custom stage backdrops",
      "Flower & fabric styling",
      "Bride-groom seating arrangements",
      "Stage lighting design",
    ],
  },
  {
    slug: "birthday-party-decoration",
    title: "Birthday Party Decoration",
    image: img("photo-1785837623454-3025f7c7a005"),
    short:
      "Playful, colourful setups for kids and grown-ups alike, matched to your party theme.",
    features: [
      "Theme-based decor",
      "Balloon & light arrangements",
      "Cake table styling",
      "Entry gate & photo corner",
    ],
  },
  {
    slug: "reception-decoration",
    title: "Reception Decoration",
    image: img("photo-1745573673043-43a4f3b91466"),
    short:
      "Refined reception arrangements with ambient lighting, comfortable seating and a beautiful couple stage.",
    features: [
      "Couple stage & backdrop",
      "Ambient & decorative lighting",
      "Guest seating & pathways",
      "Welcome desk styling",
    ],
  },
  {
    slug: "lighting-flower-decoration",
    title: "Lighting and Flower Decoration",
    image: img("photo-1766944695286-8e7c18f0fda9"),
    short:
      "Warm string lights, chandeliers and fresh flower styling that transform any venue after dark.",
    features: [
      "Decorative & LED lighting",
      "Fresh and artificial flower work",
      "Entrance archways",
      "Venue-wide illumination",
    ],
  },
  {
    slug: "haldi-engagement-ceremony",
    title: "Haldi and Engagement Ceremony",
    image: img("photo-1729237261107-6fc4279f6d1c"),
    short:
      "Bright, traditional setups for haldi, mehendi and engagement ceremonies at home or outdoors.",
    features: [
      "Traditional seating & mandap-style setup",
      "Marigold & floral decor",
      "Cozy canopy arrangements",
      "Day & evening setups",
    ],
  },
  {
    slug: "all-types-of-events",
    title: "All Types of Events",
    image: img("photo-1772127822514-682aeffcc0d3"),
    short:
      "Anniversaries, community functions, corporate gatherings and festivals — one team for every occasion.",
    features: [
      "Complete event setup",
      "Stage coordination",
      "Decor, seating & lighting",
      "End-to-end arrangements",
    ],
  },
];

export const GALLERY = [
  { src: img("photo-1772127822525-7eda37383b9f"), cat: "weddings", title: "Grand Wedding Tent Setup" },
  { src: img("photo-1708606811579-23b18fc48007"), cat: "stages", title: "Wedding Stage Decor" },
  { src: img("photo-1729237261107-6fc4279f6d1c"), cat: "haldi", title: "Haldi Ceremony Setup" },
  { src: img("photo-1745573673043-43a4f3b91466"), cat: "receptions", title: "Reception Arrangement" },
  { src: img("photo-1766944695286-8e7c18f0fda9"), cat: "lighting", title: "Evening Lighting Decor" },
  { src: img("photo-1657816925116-9bbb2a45fb6d"), cat: "pandals", title: "Pandal Setup" },
  { src: img("photo-1745573674151-c51aa29fc9ac"), cat: "weddings", title: "Wedding Venue Decor" },
  { src: img("photo-1771992223384-96d5914e99f9"), cat: "stages", title: "Stage & Seating" },
  { src: img("photo-1772127822514-682aeffcc0d3"), cat: "pandals", title: "Event Tent & Pandal" },
];

export const GALLERY_FILTERS = [
  { key: "all", label: "All" },
  { key: "weddings", label: "Weddings" },
  { key: "stages", label: "Stages" },
  { key: "pandals", label: "Pandals" },
  { key: "lighting", label: "Lighting" },
  { key: "haldi", label: "Haldi & Engagement" },
  { key: "receptions", label: "Reception" },
];

export const EVENT_TYPES = [
  "Wedding",
  "Reception",
  "Birthday Party",
  "Haldi & Engagement",
  "Lighting & Flowers",
  "Other",
];

export const PILLARS = [
  {
    icon: "badge",
    title: "Quality Materials",
    text: "Strong, weather-ready tents, pandals and furniture — chosen to look beautiful and hold up through the whole event.",
  },
  {
    icon: "sparkles",
    title: "Beautiful Decorations",
    text: "Thoughtful drapes, florals and lighting designed around your occasion, your theme and your venue.",
  },
  {
    icon: "clock",
    title: "Timely Arrangements",
    text: "Setup completed well before your guests arrive, and cleared away promptly after the celebration.",
  },
  {
    icon: "heart",
    title: "Customer Satisfaction",
    text: "We plan with you at every step, so what we build on the day is exactly what you imagined.",
  },
];
